// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent implements OnInit {
    public title = 'Are You Sure?';
    public message = 'Are you sure you want to continue?';
    public btnText = 'Yes';
    public richMessage: any;

    constructor(
        private dialogRef: MatDialogRef<ConfirmModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit() {
        if (this.data.title) {
            this.title = this.data.title;
        }

        if (this.data.message) {
            this.message = this.data.message;
        }

        if (this.data.btnText) {
            this.btnText = this.data.btnText;
        }

        if (this.data.richMessage) {
            this.richMessage = this.data.richMessage;
        }
    }

    onClose(response: boolean) {
        this.dialogRef.close(response);
    }
}
